import React from 'react';

function Spining() {
    return (
        <div id='loader'>
            <div className="spinner-border m-5" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
}

export default Spining;